module.exports = {
  "title": "walk",
  "id": "walk",
  "info": [
    {
      "text": "Make a piece move using the arrow keys",
      "image": "provision/glitches/walk/walk.gif"
    },
    {
      "text": "Use the variables panel to use different keys or change the movement speed.",
      "image": "provision/glitches/walk/variables.gif"
    }
  ],
  "category": "keyboard",
  "color": "pink",
  "icon": "gamepad",
  "searchTags": ["move", "control", "arrow", "controller", "keyboard"],
  "exposedVariables": [
    {
      "tooltip":"Set what keyboard key moves this piece left",
      "value": "left arrow",
      "variableName": "left key",
      "spriteName": "$glitch_target",
      "input": {
        "type": "key"
      }
    },
    {
      "tooltip":"Set what keyboard key moves this piece right",
      "value": "right arrow",
      "variableName": "right key",
      "spriteName": "$glitch_target",
      "input": {
        "type": "key"
      }
    },
    {
      "tooltip":"Set what keyboard key moves this piece up",
      "value": "up arrow",
      "variableName": "up key",
      "spriteName": "$glitch_target",
      "input": {
        "type": "key"
      }
    },
    {
      "tooltip":"Set what keyboard key moves this piece down",
      "value": "down arrow",
      "variableName": "down key",
      "spriteName": "$glitch_target",
      "input": {
        "type": "key"
      }
    },
    {
      "tooltip":"Set how fast this piece moves",
      "value": 5,
      "variableName": "walk speed",
      "spriteName": "$glitch_target",
      "input": {
        "type": "slider",
        "min": -30,
        "max": 30
      }
    }
  ],
  "codeImage": "provision/glitches/walk/walk.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "image": "provision/parts/walk/walk.svg"
};